import { render } from "./ListAbsenView.vue?vue&type=template&id=1ff79627"
import script from "./ListAbsenView.vue?vue&type=script&lang=js"
export * from "./ListAbsenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__